import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Draggable } from "react-beautiful-dnd";
import { Card } from 'react-bootstrap';
import { isToday, usePermission } from "../../../helpers/common";
import { DISPLAY_DATETIME_FORMAT } from '../../../constants';

const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});

const EquipmentCard = (props) => {    
    const { equipment, type } = props;
    if (!equipment || !props.onSearchFilter(equipment.name)) return <></>;

    const allow = usePermission();
    const isAllowEdit = allow("equipment-group", "edit") ? isToday(props.search.range) : false;

    return (equipment && <Draggable
        draggableId={equipment.id}
        index={props.index}
        isDragDisabled={!isAllowEdit}
    >
        {(provided, snapshot) => (
            <div ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={getItemStyle(provided.draggableProps.style)}>
                <Card className={`${snapshot.isDragging ? "dragging" : ""} ${props.isChanged && "changed"}`}>
                    <div className="option-details">
                        <div className="option-name" title={type === 'device' ? equipment.id : equipment.name}>{equipment.name}</div>
                        {equipment.subName && type !== 'operator' && <div className="option-sub-name">{equipment.subName}</div>}
                        {isToday(props.search.range) && !props.isChanged && equipment.subInfo && type === 'operator' && <div className="option-sub-name text-danger">
                            Last logout {moment(equipment.subInfo).format(DISPLAY_DATETIME_FORMAT)}</div>}
                    </div>
                </Card>
            </div>)}
    </Draggable>
    )
}

const mapStateToProps = (state, ownProps) => {
    const { analyze, egKanban } = state;
    const listById = egKanban.optionList[ownProps.type].listById;
    return ({
        equipment: listById.hasOwnProperty(ownProps.id) ? listById[ownProps.id] : null,
        isChanged: egKanban.optionList[ownProps.type].filteredList.indexOf(ownProps.id) < 0,
        search: { range: analyze.searchParams.range }
    });
}

export default connect(mapStateToProps)(EquipmentCard);